import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import FileUpload from '../Common/FormsyFileUpload';
import Form from '../Common/Form.react';
import UserActions from '../../actions/UserActionCreator';
import UserImportStore from '../../stores/UserImportStore';


class UserImportForm extends Component {

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onError = this.onError.bind(this);
        UserActions.getImportHeaders();
    }

    onChange(fileUploadName, targetFile = {}) {
        UserActions.setTargetFile(targetFile);
    }

    onSave(formData) {
        const {fileUploadName, allowedTypes} = this.props;
        if (!formData[fileUploadName]) {
            return UserActions.emitError('Please select file to upload');
        }
        if (!allowedTypes.includes(formData[fileUploadName].type)) {
            return UserActions.emitError('Please select a valid CSV file');
        }
        UserActions.importUsers(formData);
    }

    onError(lastErrorMessage) {
        UserActions.emitError(lastErrorMessage);
    }

    render() {
        const { data, isSuppressedSuccessMessage, isProcessed } = this.state;
        const errors = data.errors.map((error, index) => <li key={index}>{error}</li>);
        const warnings = data.warnings.map((warning, index) => <li key={index}>{warning}</li>);
        const errorsList = !!errors.length ? <ul>{errors}</ul> : null;
        const warningsList = !!warnings.length ? <ul>{warnings}</ul> : null;
        const fieldList = (!!this.state.headers ? <span>{this.state.headers.join(', ')}</span> : null);
        
        return (
            <div>
                <Form
                    suppressRedirect={this.props.suppressRedirect}
                    suppressSuccessMessage={isSuppressedSuccessMessage}
                    title={this.props.title}
                    onSave={this.onSave}
                    onError={this.onError}
                >
                    <div className='cent-cards'>
                        <Card className='cent-card' >
                            <CardHeader
                                title='Import user from CSV'
                                subtitle='File must include the column headings in the first row.'
                            />
                            <Divider/>
                            <CardText>
                                <div className='cent-flex-row'>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            <li>Please use the following column names:</li>
                                            <li>{fieldList}</li>
                                            <li>The following columns require a value:</li>
                                            <li>firstname, lastname, email</li>
                                        </ul>
                                    </div>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            <li>
                                                <Link to="/usr/users/import/template.csv" download="users.csv" target="_blank">
                                                    Download template
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/usr/users/import/template.csv?withAttributes=true" download="users.csv" target="_blank">
                                                    Download template with attribute headers
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/usr/users/import/template.csv?withAttributes=true&withManagers=true" download="users.csv" target="_blank">
                                                    Download template with attribute and manager relation headers
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </CardText>
                            <CardText>
                                <Checkbox
                                    name="withAttributes"
                                    label="Import includes attribute values"
                                />
                                <Checkbox
                                    name="withManagers"
                                    label="Import includes manager relations"
                                />
                                <Checkbox
                                    name="updateExisting"
                                    label="Update existing user records"
                                />
                                <Checkbox
                                    name="enableAll"
                                    label="Enable all users"
                                />
                            </CardText>
                            <CardText>
                                <FileUpload name={this.props.fileUploadName} required onChange={this.onChange}/>
                            </CardText>
                    </Card>
                    </div>
                </Form>
                <Dialog
                    title="Results"
                    open={isProcessed}
                    onRequestClose={() => UserActions.setProcessed(false)}
                    autoScrollBodyContent={true}
                >
                    <p>Number of rows added: {data.successCount}</p>
                    <p>Number of rows skipped: {data.totalProcessedCount - data.successCount}</p>
                    <p>Total rows processed: {data.totalProcessedCount}</p>
                    <p>Errors: {errors.length}</p>
                    {errorsList}
                    <p>Warnings: {warnings.length}</p>
                    {warningsList}
                </Dialog>
            </div>
        );
    }
}

UserImportForm.propTypes = {
    title: PropTypes.string,
    fileUploadName: PropTypes.string,
    allowedTypes: PropTypes.array
};
UserImportForm.defaultProps = {
    title: 'Import users',
    fileUploadName: 'import',
    allowedTypes: ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    suppressRedirect: true
};
UserImportForm.getStores = () => ([UserImportStore]);
UserImportForm.calculateState = () => UserImportStore.getState();

export default Container.create(UserImportForm, {withProps: true});
